import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AUTH_CONFIG, AuthService, PORTAL_DISPLAY_NAME } from '@lr/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map, switchMap } from 'rxjs/operators';

const PORTAL_LABELS: Record<string, string> = {
  client: 'Client Portal',
  member: 'Member Portal',
  attorney: 'Attorney Portal'
};

/**
 * Shared 403 Forbidden page
 * Displayed when the user is not registered or lacks permission
 */
@Component({
  selector: 'lib-access-denied',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent {
  private authService = inject(AuthService);
  private router = inject(Router);
  private config = inject(AUTH_CONFIG);
  private portalDisplayName = inject(PORTAL_DISPLAY_NAME, { optional: true });

  /** Wait for Auth0 to finish loading before reading the profile email. */
  email = toSignal(
    this.authService.isLoading$.pipe(
      filter(loading => !loading),
      switchMap(() => this.authService.user$),
      map(user => user?.email?.trim() || null)
    ),
    { initialValue: null }
  );

  readonly portalName =
    this.portalDisplayName
    ?? PORTAL_LABELS[this.config.portalKey]
    ?? 'this portal';

  onLogInAgain(): void {
    void this.router.navigate(['/logout']);
  }

  onBackToDashboard(): void {
    void this.router.navigate(['/dashboard']);
  }
}
